import { Button, Grid, Stack, Typography } from '@mui/material';
import { useCallback } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useNavigate } from 'react-router-dom';

import { Icon, Loading, Mask } from '@hapvida/hapvida-core-components';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import { MovimentationDetailRouter } from '@flows/private/movements/pages/MovementDetails/router';
import { MovimentationStepRouter } from '@flows/private/movements/pages/MovimentationSteps/router';
import { useAuth } from '@hooks';
import { MOVIMENTATION_STEPS_KEYS } from 'constants/private/movements/newMovementSteps';

import { UploadName } from '../../../desktop/components/MovementListCard/components';
import { ActionButton, Line, StyledGrid } from './styles';
import type { MovementsListCardMobileProps } from './types';

export function MovementListCardMobile({
  movementsList,
  hasNextPage,
  fetchNextPage,
}: Readonly<MovementsListCardMobileProps>) {
  const navigateTo = useNavigate();

  const { selectedCompany } = useAuth();

  const movementsData =
    movementsList?.pages?.map(movement => movement?.movements)?.flat() ?? [];

  const handleEdit = useCallback(
    (id: string) => {
      navigateTo(
        MovimentationDetailRouter.dynamicPath({
          movementId: id,
        }),
      );
    },
    [navigateTo],
  );

  const handleNewMovement = () => {
    navigateTo(
      MovimentationStepRouter.dynamicPath({
        movimentationStep: MOVIMENTATION_STEPS_KEYS.MOVIMENTATION_FILE,
      }),
    );
  };

  return (
    <>
      <Button variant="contained" color="success" onClick={handleNewMovement}>
        Nova movimentação
      </Button>
      <InfiniteScroll
        dataLength={movementsData?.length}
        hasMore={!!hasNextPage}
        next={fetchNextPage}
        loader={<Loading animationProps={{ height: 20, width: 20 }} />}
        height={'800px'}
      >
        <Grid container gap={1} flexDirection="row" flexWrap="wrap">
          {movementsData?.map(movement => (
            <Grid item xs={12} key={movement?.id}>
              <Line container alignItems="center">
                <Stack
                  flexDirection="row"
                  alignItems="flex-start"
                  mb={2}
                  width="100%"
                  justifyContent="space-between"
                >
                  <Stack
                    alignItems="flex-start"
                    justifyContent="flex-start"
                    gap={1}
                  >
                    <Stack direction="row" alignItems="center" gap={1}>
                      <Typography variant="text">
                        {movement?.number ?? '-'}
                      </Typography>
                    </Stack>
                    <Stack>
                      {movement?.uploadName && (
                        <UploadName
                          uploadName={movement?.uploadName}
                          fileName={movement?.fileName}
                          selectedCompany={selectedCompany}
                        />
                      )}
                    </Stack>
                    <Typography
                      variant="body2"
                      overflow="hidden"
                      textOverflow="ellipsis"
                    >
                      {Mask.date(movement?.createdAt, true)}
                    </Typography>
                  </Stack>
                </Stack>
                <StyledGrid item xs={12}>
                  <ActionButton
                    onClick={() => handleEdit(movement?.id)}
                    color="secondary"
                    variant="contained"
                    size="small"
                    fullWidth
                    endIcon={
                      <Icon
                        color={NEW_COLORS.BASE.WHITE}
                        name="actions-b2b-chevron-right"
                        size={20}
                      />
                    }
                  >
                    Ver mais
                  </ActionButton>
                </StyledGrid>
              </Line>
            </Grid>
          ))}
        </Grid>
      </InfiniteScroll>
    </>
  );
}
